<div class="menu-crud-base">

	<!--		<div class="menu-crud-content-t">-->
	<!--			<ng-content select="[PanelTop]"></ng-content>-->
	<!--		</div>-->


	<div class="menu-crud-content-inner conf-grid">


		@for (
				spacer of gridConf(); track spacer.uuid + $index) {
			<div class="grid-item bg-black text-white"></div>
			<!--					<div class="bg-black"></div>-->
		}


		@for (
				c of conf(); track c.uuid) {
			<app-menu-crud-tile class="grid-item" [conf]="c" [toggle]="toggle()"></app-menu-crud-tile>
		}
	</div>


</div>